import { render, staticRenderFns } from "./TextAreaAction.vue?vue&type=template&id=5db70dfb"
import script from "./TextAreaAction.vue?vue&type=script&lang=js"
export * from "./TextAreaAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports